import { jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { StyledTextCTA } from './TextCTA.styles.js';
import COLORS from '../../constants/colors.js';
import { useGenericAsyncHandler } from '../../hooks/useGenericAsyncHandler.js';

const TextCTA = forwardRef((props, ref) => {
    const { children, disabled, color = COLORS.BLUE, id, weight = "bold", iconNode, size = "s", underline, type = "button", } = props;
    const asynHandler = useGenericAsyncHandler(props === null || props === void 0 ? void 0 : props.onClick);
    return (jsxs(StyledTextCTA, Object.assign({ id: id, color: color, weight: weight, size: size, disabled: disabled || (asynHandler === null || asynHandler === void 0 ? void 0 : asynHandler.loading), underline: underline, type: type }, ((props === null || props === void 0 ? void 0 : props.onClick) && {
        onClick: asynHandler === null || asynHandler === void 0 ? void 0 : asynHandler.execute,
    }), { children: [iconNode, " ", children] })));
});

export { TextCTA as default };
//# sourceMappingURL=TextCTA.js.map
